
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  reactive
} from "vue";
import { Image, Steps, Step, Button, Popup, Dialog } from "vant";
import Account from "@/api/account";
import dayjs from "dayjs";

export default defineComponent({
  name: "DetailOld",
  props: {
    approveInfo:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return { show: false };
  },
  components: {
    "van-image": Image,
    "van-step": Step,
    "van-steps": Steps,
    "van-button": Button,
    "van-popups": Popup
  },
  setup(props, ctx) {
    const visitor_name = ref("");
    const user_count = ref("");
    const visitor_tel = ref("");
    const approve_photo = ref("");
    const visitor_reason = ref("");
    const touser_name = ref("");
    const visitor_in_time = ref("");
    const create_date = ref("");
    const approve_status = ref("");
    const status = ref(0);
    const id = ref("");
    const approve_user_id = ref("");
    //const envs = ref('https://res-mal.12kcool.com/')
    const envs = ref("https://res-k12.12kcool.com/");
    
    const getstatus = (statu: number) => {
      let val = "";
      if (statu === 0) {
        val = "待审批";
      } else if (statu === 1) {
        val = "审批拒绝";
      } else {
        val = "审批通过";
      }
      return val;
    };
    watch(()=>props.approveInfo, (val)=>{
      console.log('approveInfo', val)
      const data = val || {}
      visitor_name.value = data.visitor_name;
      user_count.value = data.user_count;
      visitor_tel.value = data.visitor_tel;
      approve_photo.value = data.approve_photo;
      visitor_reason.value = data.visitor_info.visitor_reason;
      touser_name.value = data.visitor_info.touser_name;
      visitor_in_time.value = dayjs(data.visitor_in_time).format(
        "YYYY-MM-DD HH:mm"
      );
      create_date.value = dayjs(data.create_date).format(
        "YYYY-MM-DD HH:mm"
      );
      approve_status.value = getstatus(data.visitor_info.approve_status);
      status.value = data.visitor_info.approve_status;
    },{
      deep: true,
      immediate: true
    })
    const setApprove = (status?: number) => {
      let approvalId = ''
      const params = {
        approve_user_id: approve_user_id.value,
      }
      if (!status) {
        approvalId = '-1'
      }
      Dialog.confirm({
        title: '提示',
        message: `确定要${status === 2 ? "同意" : "拒绝"}吗？`,
      })
        .then(async () => {
          // on confirm
          const [err, data] = await Account.setApprove(approvalId || id.value, status, params);
          
          ctx.emit('refresh');
          console.log(data);
        })
        .catch(() => {
          // on cancel
        });
    };
    const setid = async (ids: any) => {
      id.value = ids;
    };
    const setVisitorId = async (ids: any) => {
      approve_user_id.value = ids;
    };

    onMounted(async () => {
      // Notify('onMounteSSSd')
    });

    return {
      envs,
      visitor_name,
      user_count,
      visitor_tel,
      approve_photo,
      visitor_reason,
      touser_name,
      visitor_in_time,
      create_date,
      approve_status,
      status,
      setApprove,
      setid,
      setVisitorId,
      getstatus,
      id,
      approve_user_id
    };
  },
  created() {
    console.log('query', this.$route.query);
    this.setid(this.$route.query.touser_id);
    this.setVisitorId(this.$route.query.approve_user_id);
  }
});
